import React from "react";
import { ShieldCheck, Wifi, QrCode, Languages } from "lucide-react";
import Reveal from "./Reveal";
import { PulseDivider } from "./PulseQR";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = [ShieldCheck, Wifi, QrCode, Languages];

export default function WhyNepal() {
  const { t } = useLanguage();
  const w = t.why;

  return (
    <section
      id="why-nepal"
      data-testid="why-nepal-section"
      className="relative py-24 sm:py-32 text-white overflow-hidden"
      style={{ background: "linear-gradient(180deg, #0F2A47 0%, #0A2138 100%)" }}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          maskImage: "radial-gradient(ellipse 80% 60% at 50% 20%, black, transparent 78%)",
          WebkitMaskImage: "radial-gradient(ellipse 80% 60% at 50% 20%, black, transparent 78%)",
        }}
      />

      <div className="relative shell">
        <div className="max-w-[680px]">
          <Reveal className="kicker text-green">{w.kicker}</Reveal>
          <Reveal as="h2" delay={1} className="mt-5 font-display text-[30px] sm:text-[40px] lg:text-[46px] font-semibold text-white tracking-tight leading-[1.1]">
            {w.h2}
          </Reveal>
        </div>

        <div className="mt-8 opacity-70">
          <Reveal delay={1}>
            <PulseDivider className="w-full h-8" />
          </Reveal>
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {w.cards.map((card, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <Reveal delay={Math.min(i + 1, 4)} key={card.l} className="glow rounded-2xl bg-white/[0.04] border border-white/[0.09] p-6">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-xl bg-white/[0.06] text-green">
                  <Icon size={18} strokeWidth={1.7} />
                </span>
                <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.18em] text-white/45">{card.l}</div>
                <h3 className="mt-2 font-display text-[17px] font-semibold text-white tracking-tight">{card.h}</h3>
                <p className="mt-2 text-[13.5px] text-white/60 leading-[1.6]">{card.b}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
